import React from 'react'
import * as blueprint from '@adc/blueprint'
import {
  PropertyInfo,
  ListingCardIndicator,
  LeftSidePropertyValue,
  ListingCardLinkProps,
} from '../listingCard/cardParts'
import classnames from 'classnames/bind'
import cls from './styles.scss'
import type { Listing, Address, Maybe } from '@adc/sdk/types'

const { getAddressLine } = blueprint.listing.utils.card

const cx = classnames.bind(cls)

interface PopupAddressProps {
  address?: Maybe<string>[]
  elmId?: string
}

const PopupAddress = ({ address, elmId }: PopupAddressProps) => {
  if (!address || address.length < 2 || !address[0] || !address[1]) return null

  const cleanedSecondLine = address[1].substring(0, address[1].lastIndexOf(','))
  const fullAddress = `${address[0]}, ${cleanedSecondLine}`

  return (
    <div
      data-elm-id={`${elmId}_address_field`}
      className={cx('address-field', 'nowrap')}
    >
      {fullAddress}
    </div>
  )
}

interface CardImageProps {
  listing: Listing
  listingPhotoUrl?: string
  defaultPhotoUrl?: string
  className?: string
}

const CardImage = ({
  listing,
  listingPhotoUrl,
  defaultPhotoUrl,
  className,
}: CardImageProps) => {
  const altTextImage = getAddressLine(
    listing.seller_property as Partial<Address>
  )

  return (
    <div
      className={cx('property-card-image-container', className)}
      style={{
        backgroundImage: `url(${defaultPhotoUrl})`,
      }}
    >
      <div
        className={cx('property-card-image-background')}
        style={{
          backgroundImage: `url(${listingPhotoUrl})`,
        }}
        role='img'
        aria-label={altTextImage}
      />
    </div>
  )
}

export {
  PopupAddress,
  CardImage,
  // PropertyValue,
  LeftSidePropertyValue as PropertyValue,
  PropertyInfo,
  // AuctionInfo
  ListingCardIndicator as AuctionInfo,
  ListingCardLinkProps,
}
